import { Component } from '@angular/core';
import { FeatureTogglesFacade } from '@cigna/features';
import { OmniLiveAvailabilityFacade } from '@cigna/omni/live-availability-state';
import { Observable } from 'rxjs';
@Component({
  selector: 'cigna-omni-entry',
  templateUrl: './omni-entry.component.html',
  styleUrls: ['./omni-entry.component.scss'],
})
export class OmniEntryComponent {
  public hasPrechatWelcomeFeature$ = this.features.featuresEnabled([
    'enableNewPreChatWelcome',
  ]);
  public useRightNowChat$ = this.features.featuresEnabled(['useRightNowChat']);
  public liveClinicianChat$ = this.features.featuresEnabled([
    'liveClinicianChat',
  ]);
  public liveSupportChat$ = this.features.featuresEnabled(['liveSupportChat']);
  public personalGuideChat$ = this.features.featuresEnabled([
    'personalGuideChat',
  ]);
  public consumerSpecificChat$ = this.features.featuresEnabled([
    'hasRestrictedChat',
    'shouldEnableChat',
  ]);
  public liveChatAvailable$: Observable<boolean> =
    this.liveAvailabilityFacade.liveChatAvailable$;

  constructor(
    private features: FeatureTogglesFacade,
    private liveAvailabilityFacade: OmniLiveAvailabilityFacade,
  ) {}
}
